/**
 * Central asset manifest.
 *
 * Designers and non-developers can swap images here without touching JSX.
 * All runtime image paths used in the app should be imported from this file.
 */

export const assets = {
  // Brand
  logo: '/assets/logo.png',

  // Backgrounds / patterns
  backgroundPattern: '/assets/background-pattern.jpg',

  // Navigation / scroll arrows
  arrowDown: '/assets/arrow-down.svg',
  arrowUp: '/assets/arrow-up.svg',
  arrowLeft: '/assets/arrow-left.png',
  arrowRight: '/assets/arrow-right.png',

  // Subscription / book imagery
  bookCover1: '/assets/book-cover-1.jpg',
  bookCover2: '/assets/book-cover-2.jpg',
  poster5: '/assets/poster-5.jpg',

  // Carousel posters (SVG, designer-editable)
  posters: {
    thematic: '/assets/posters/poster-thematic.svg',
    bespoke: '/assets/posters/poster-bespoke.svg',
    gift: '/assets/posters/poster-gift.svg',
    company: '/assets/posters/poster-company.svg',
  },

  // About Us / FAQ section assets
  aboutUs: {
    bookseller: '/assets/about-us/my_pretty_ass button.svg',
    individualCard: '/assets/about-us/Indywidualne button.svg',
    thematicCard: '/assets/about-us/Tematyczne button.svg',
    faqHeader: '/assets/about-us/FAQ button.svg',
    contactFrame: '/assets/about-us/Contact frame.svg',
  },
}

/**
 * Helper to resolve an asset key to its public path.
 * Falls back to the input if it already looks like an absolute URL/path.
 */
export function getAsset(key) {
  if (typeof key !== 'string') return ''
  if (key.startsWith('http') || key.startsWith('/')) return key
  return assets[key] || ''
}
